import React, { useEffect, useRef, useState } from "react";
import * as func from "../../../common/manipurCommon/FunctionCalls";
import * as api from "../../../common/manipurCommon/API";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader, ModalTitle } from "react-bootstrap";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { usePermissions } from "../../../common/PermissionContext";
import Select from "react-select";
import { Link, useLocation } from "react-router-dom";
import ImageWithBasePath from "../../../../core/data/img/ImageWithBasePath";
import Swal from "sweetalert2";
import Utils from "../../../common/manipurCommon/Utils";

const CompClasses = () => {

    const [sportList, setSportList] = useState<any[]>([]);
    const [clsList, setClsList] = useState<any[]>([]);
    const [compClsId, setCompClsId] = useState("");
    const [sportId, setSportId] = useState("");
    const [clsName, setClsName] = useState("");
    const [status, setStatus] = useState("");
    const [searchInput, setSearchInput] = useState("");
    const [openModal, setOpenModal] = useState(false);
    const [isEdit, setIsEdit] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    const formRef = useRef(null);

    const { permissionsMap } = usePermissions();
    const location = useLocation();

    const currentPath = location.pathname;
    const currentPermissions = permissionsMap[currentPath] || [];

    useEffect(() => {
        async function fetchCompetitionClasses() {
            setIsLoading(true);
            const compResponse = await func.competitionClasses(null);
            setClsList(Array.isArray(compResponse) ? compResponse : [])
            setIsLoading(false);
        }
        fetchCompetitionClasses();
    }, []);

    const filteredData = clsList.filter((datas) => {
        const values = Object.values(datas).map((value) =>
            value !== null && value !== undefined ? value.toString().toLowerCase() : '');
        return values.some((value) => value.includes(searchInput.toLowerCase()));
    });

    const slNoRender = (rowData, column) => {
        return column.rowIndex + 1;
    };

    const compNameRender = (rowData) => {
        return <span>{rowData.name}</span>
    };

    const compStatusRender = (rowData) => {
        return <span>{(rowData.status == 1) ? "Active" : "Inactive"}</span>
    };

    const selectCustom = {
        control: (base) => ({
            ...base,
            borderRadius: "6px",     // tighter radius since the box is smaller
            background: "#FAFAFA",
            border: "none",
            boxShadow: "none",
            minHeight: "45px",       // ensures it never grows taller
            height: "45px",          // fixed height
        }),
        valueContainer: (base) => ({
            ...base,
            height: "45px",          // matches control
            display: "-webkit-inline-box",
            alignItems: "center",    // centers text vertically
            padding: "0 6px",        // adjust padding to avoid text clipping
        }),
        input: (base) => ({
            ...base,
            margin: "0px",
            padding: "0px",
        }),
        indicatorsContainer: (base) => ({
            ...base,
            height: "45px",          // make dropdown arrow fit
        }),
        dropdownIndicator: (base) => ({
            ...base,
            padding: "2px",          // tighter padding for small height
        }),
        clearIndicator: (base) => ({
            ...base,
            padding: "2px",          // smaller clear (x) button
        }),
        placeholder: (base) => ({
            ...base,
            color: "#aaa",
        }),
        singleValue: (base) => ({
            ...base,
            color: "#333",
        }),
        menu: (base) => ({
            ...base,
            zIndex: 9999,
        }),
    };

    async function newCompetitionClasses() {
        const sprt = await func.listSports(null);
        setSportList(Array.isArray(sprt) ? sprt : [])
        setIsEdit(false);
        setSportId("");
        setClsName("");
        setStatus("");
        setOpenModal(true);
    }


    const editDetails = (rowData: any) => {
        return (
            <Link to="#" onClick={() => editCompetitionClasses(rowData)}>
                <i className="feather-edit"></i>Edit
            </Link>
        );
    };

    const deleteDetails = (rowData) => {
        const ccId = rowData.id;

        return (
            <Link to="#" onClick={() => deleteCompetitionClasses(ccId)}>
                <i className="feather-trash"></i>Delete
            </Link>
        );
    };

    async function editCompetitionClasses(rowData: { id: any; }) {
        const ccId = rowData.id;
        setIsEdit(true)
        setOpenModal(true)
        setCompClsId(ccId)
        const sprt = await func.listSports(null);
        setSportList(Array.isArray(sprt) ? sprt : [])
        const getDetails = await func.competitionClasses(ccId);
        setSportId(getDetails.sporteventid);
        setClsName(getDetails.name);
        setStatus(getDetails.status);
    }

    function handleSubmit(e) {
        e.preventDefault();
        if (!formRef.current.checkValidity()) {
            // Manually trigger native HTML5 validation message
            formRef.current.reportValidity();
        } else {
            if (isEdit) {
                updateCompetitionClasses();
            } else {
                const formData = new FormData();
                formData.append("sporteventid", sportId);
                formData.append("name", clsName);

                const compPrfmc = api.CompetitionClasses;
                fetch(compPrfmc, {
                    method: "POST",
                    headers: {
                        "Authorization": 'Bearer ' + Utils.getAccessToken()
                    },
                    body: formData
                })
                    .then((response) => response.json())
                    .then((result) => {
                        if (result.error == false) {
                            Swal.fire({
                                title: 'Success',
                                text: result.message,
                                icon: 'success',
                                confirmButtonText: 'OK',
                                allowOutsideClick: false,
                                allowEscapeKey: false
                            }).then((res) => {
                                if (res.isConfirmed) {
                                    window.location.reload(); // 🔁 Reload only after OK is clicked
                                }
                            });
                        } else {
                            if (result.code == 401) {
                                Utils.logoutUser();
                            }
                            Swal.fire({
                                title: 'Error',
                                text: result.message,
                                icon: 'error',
                                confirmButtonText: 'OK',
                                allowOutsideClick: false,
                                allowEscapeKey: false
                            }).then((res) => {
                                if (res.isConfirmed) {
                                    window.location.reload(); // 🔁 Reload only after OK is clicked
                                }
                            });
                        }
                    })
            }
        }
    }

    function updateCompetitionClasses() {
        const formData = new FormData();
        formData.append("sporteventid", sportId);
        formData.append("name", clsName);
        formData.append("status", status);
        const updateCompCls = api.CompetitionClasses + '/' + compClsId;
        fetch(updateCompCls, {
            method: "POST",
            headers: {
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            },
            body: formData
        })
            .then((response) => response.json())
            .then((result) => {
                if (result.error == false) {
                    Swal.fire({
                        title: 'Success',
                        text: result.message,
                        icon: 'success',
                        confirmButtonText: 'OK',
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    }).then((res) => {
                        if (res.isConfirmed) {
                            window.location.reload(); // 🔁 Reload only after OK is clicked
                        }
                    });
                } else {
                    if (result.code == 401) {
                        Utils.logoutUser();
                    }
                    Swal.fire({
                        title: 'Error',
                        text: result.message,
                        icon: 'error',
                        confirmButtonText: 'OK',
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    }).then((res) => {
                        if (res.isConfirmed) {
                            window.location.reload(); // 🔁 Reload only after OK is clicked
                        }
                    });
                }
            })
    }

    function deleteCompetitionClasses(ccId: string) {
        const delCompFrmt = api.CompetitionClasses + '/' + ccId + '/0';
        fetch(delCompFrmt, {
            method: "DELETE",
            headers: {
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            }
        })
            .then((response) => response.json())
            .then((result) => {
                if (result.error == false) {
                    Swal.fire({
                        title: 'Success',
                        text: result.message,
                        icon: 'success',
                        confirmButtonText: 'OK',
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    }).then((res) => {
                        if (res.isConfirmed) {
                            window.location.reload(); // 🔁 Reload only after OK is clicked
                        }
                    });
                } else {
                    if (result.code == 401) {
                        Utils.logoutUser();
                    }
                    Swal.fire({
                        title: 'Error',
                        text: result.message,
                        icon: 'error',
                        confirmButtonText: 'OK',
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    }).then((res) => {
                        if (res.isConfirmed) {
                            window.location.reload(); // 🔁 Reload only after OK is clicked
                        }
                    });
                }
            })
    }

    return (
        <>
            {isLoading && (
                <div id="global-loader">
                    <div className="loader-img">
                        <ImageWithBasePath src="assets/img/loader.png" className="img-fluid" alt="Global" />
                    </div>
                </div>
            )}
            <div className="content container" style={{ maxWidth: "1500px", paddingTop: "10px" }}>
                <div className="row">
                    <div className="sortby-section">
                        <div className="sorting-info">
                            <div className="row align-items-center">
                                <div className="col d-flex justify-content-between">
                                    <h4>Competition Classes</h4>
                                    {currentPermissions.includes("add") ?
                                        <Link
                                            to="#"
                                            className="btn"
                                            onClick={() => { newCompetitionClasses() }}
                                            data-bs-toggle="tooltip"
                                            style={{ fontSize: "24px", padding: "0px" }}
                                            title="Create Competition Classes">
                                            <i className="feather-plus" />&nbsp;
                                        </Link>
                                        : null
                                    }
                                </div>

                                <div className="col-lg-12 col-sm-12 text-end dataTables_filter">
                                    <label>
                                        <input
                                            type="text"
                                            value={searchInput}
                                            onChange={(e) => setSearchInput(e.target.value)}
                                            style={{ height: "40px" }}
                                            placeholder="Search"
                                            className="form-control"
                                        />
                                    </label>
                                </div>
                            </div>
                            <div className="tab-content">
                                <div
                                    className="tab-pane fade show active"
                                    id="nav-Recent"
                                    role="tabpanel"
                                    aria-labelledby="nav-Recent-tab"
                                    tabIndex={0}
                                >
                                    <div className="table-responsive table-datatble">
                                        <DataTable
                                            className="table datatable"
                                            value={filteredData}
                                            paginator
                                            rows={10}
                                            rowsPerPageOptions={[10, 25, 50, 100]}
                                            // currentPageReportTemplate="{first}- {last} of {totalRecords} entries"
                                            pageLinkSize={3}
                                        >
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="slNo"
                                                body={slNoRender}
                                                header="Sl &nbsp; No"
                                            ></Column>
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="name"
                                                header="Class"
                                                body={compNameRender}
                                                className="table-inset-btn"
                                            ></Column>
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="status"
                                                header="Status"
                                                body={compStatusRender}
                                                className="table-inset-btn"
                                            ></Column>
                                            {currentPermissions.includes("edit") ?
                                                <Column
                                                    className="text-link"
                                                    body={editDetails}
                                                ></Column>
                                                : null
                                            }
                                            {currentPermissions.includes("delete") ?
                                                <Column
                                                    className="text-link"
                                                    body={deleteDetails}
                                                ></Column>
                                                : null
                                            }
                                        </DataTable>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <Modal
                show={openModal}
                size="md"
                centered>
                <ModalHeader>
                    <ModalTitle>
                        <h4 className="mb-0 upper-case">{isEdit ? "Edit " : "Add "} Competition Class</h4>
                    </ModalTitle>
                    <Button
                        variant=""
                        className="btn-close"
                        onClick={() => setOpenModal(false)}
                    ></Button>
                </ModalHeader>
                <ModalBody>
                    <form ref={formRef}>
                        <div className="col-lg-12 mb-10">
                            <div className="input-space">
                                <label className="form-label">Sport</label>
                                <Select
                                    value={sportList.find(sprt => sprt.sportsId === sportId) ? {
                                        value: sportId,
                                        label: sportList.find(sprt => sprt.sportsId === sportId).sportsName
                                    } : null}
                                    onChange={(e) => {
                                        setSportId(e.value);
                                    }}
                                    styles={selectCustom}
                                    required
                                    placeholder="Select Sport"
                                    options={sportList.map(sprt => ({
                                        value: sprt.sportsId,
                                        label: sprt.sportsName
                                    }))}>
                                </Select>
                            </div>
                        </div>
                        <div className="col-lg-12 mb-10">
                            <div className="input-space">
                                <label className="form-label">Name</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    value={clsName}
                                    onChange={(e) => {
                                        setClsName(e.target.value);
                                    }}
                                    style={{ height: "40px", padding: "17px" }}
                                    placeholder="Enter Class Name"
                                    required
                                />
                            </div>
                        </div>
                        {isEdit ?
                            <>
                                <div className="col-lg-12 mt-10">
                                    <div className="row">
                                        <div className="mb-10 col-lg-2" style={{ paddingTop: "1rem" }}>
                                            <label className="form-label">Status</label>
                                        </div>
                                        <div className="mb-10 col-lg-2" style={{ paddingTop: "1rem" }}>
                                            <div className="form-check form-switch d-flex align-items-center justify-content-end">
                                                <input
                                                    className="form-check-input text-end"
                                                    type="checkbox"
                                                    checked={status === '1'}
                                                    id="status"
                                                    onChange={(e) => {
                                                        setStatus(e.target.checked ? '1' : '0')
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </> : null
                        }
                        <ModalFooter>
                            <Button
                                className="btn-primary text-uppercase"
                                variant="success"
                                type="submit"
                                onClick={handleSubmit}
                            >
                                <b><i className="fas fa-save" />Save</b>
                            </Button>
                        </ModalFooter>
                    </form>
                </ModalBody>
            </Modal>
        </>
    );
}

export default CompClasses;